import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import { useAppContext } from '../utils/AppProvider';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import * as Yup from "yup";
import apiClient from '../../utils/apiclient';
const Login = () => {

  const localurlsend = "http://localhost:8080/api/otp/send"
  const localurlverify = "http://localhost:8080/api/otp/verify"
  const liveurlsend = "https://clone-backend.getbentobox.in/api/otp/send"
  const liveurlverify = "https://clone-backend.getbentobox.in/api/otp/verify"

  const navigate = useNavigate();




  const [step, setStep] = useState("enter_number");
  const [selectedRole, setSelectedRole] = useState("admin");
  const [phone, setPhone] = useState("");
  const [isShaking, setIsShaking] = useState(false);
  const [requestResponse, setrequestResponse] = useState({
    message: "",
    className: ""
  });
  useEffect(() => {
    if (localStorage.getItem("bentoAdmin")) {
      navigate(`/`);
    }
  }, []);

  const sendOtp = (values) => {
    const { number, role } = values;

    axios
      .post(liveurlsend, {
        number,
        role,
      })
      .then((res) => {
        setPhone(number);
        setSelectedRole(role); // we'll add this below
        setrequestResponse({
          message: "OTP sent successfully",
          className: "bg-green-100 text-green-800 px-4 py-2 rounded-md shadow",
        });
        setStep("enter_otp");
      })
      .catch((err) => {
        setrequestResponse({
          message: "Failed To send OTP",
          className: "bg-red-100 text-red-800 px-4 py-2 rounded-md shadow",
        });
        setIsShaking(true);
        setTimeout(() => setIsShaking(false), 500);
      });
  };

  const verifyOtp = async (values) => {
    try {
      const { otp } = values;

      const res = await axios.post(liveurlverify, {
        number: phone,
        otp,
        role: selectedRole,
      });

      localStorage.setItem("bentoAdmin", res.data);

      const now = new Date();
      localStorage.setItem("bentoAdminExpiry", now.getTime());

      setrequestResponse({
        message: "Logged in successfully",
        className: "bg-green-100 text-green-800 px-4 py-2 rounded-md shadow",
      });

      // Try to fetch user details, but don't block login if it fails
      try {
        const response = await apiClient.get("/user");
        if (response.data && response.data.role) {
          localStorage.setItem(
            "bentoAdminDetails",
            JSON.stringify(response.data.role.id)
          );
        }
      } catch (userErr) {
        console.warn("Could not fetch user role details, proceeding with login anyway.", userErr);
      }

      navigate("/");
    } catch (err) {
      setrequestResponse({
        message: "Invalid OTP",
        className: "bg-red-100 text-red-800 px-4 py-2 rounded-md shadow",
      });
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 500);
    }
  };

  const firstOtpRef = React.useRef(null);
  useEffect(() => {
    if (step === "enter_otp") {
      // Wait a tick to ensure input is mounted
      setTimeout(() => {
        if (firstOtpRef.current) {
          firstOtpRef.current.focus();
        }
      }, 0);
    }
  }, [step]);

  return (
    <div className='min-h-screen flex w-full font-sans bg-gray-50'>
      <style>{`
        @keyframes shakeError {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-4px); }
          80% { transform: translateX(4px); }
        }
      `}</style>

      {/* Left Branding Panel (Hidden on Mobile) */}
      <div className="hidden lg:flex w-1/2 bg-gray-900 text-white flex-col justify-center px-16 relative overflow-hidden">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20">
          <div className="absolute -top-[20%] -left-[10%] w-[70%] h-[70%] rounded-full bg-gradient-to-br from-blue-600 to-purple-600 blur-[120px]"></div>
          <div className="absolute top-[60%] -right-[20%] w-[60%] h-[60%] rounded-full bg-gradient-to-tl from-indigo-500 to-cyan-500 blur-[100px]"></div>
        </div>

        <div className="relative z-10">
          <div className="bg-white/10 w-fit p-3 rounded-xl mb-6 backdrop-blur-sm border border-white/10">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 002-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
            </svg>
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight mb-4">
            Bento Box <br />
            <span className="text-blue-400">Admin Portal</span>
          </h1>
          <p className="text-gray-400 text-lg max-w-md leading-relaxed">
            Manage your restaurant network, monitor riders, and configure subscriptions from a powerful, centralized dashboard.
          </p>
        </div>
      </div>

      {/* Right Login Panel */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">

          <div className="mb-10 lg:hidden text-center">
            <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight">Bento Box Admin</h1>
            <p className="text-gray-500 mt-2">Secure Portal Access</p>
          </div>

          <div className="bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 overflow-hidden">
            <div className="p-8 sm:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Welcome Back</h2>
              <p className="text-gray-500 text-sm mb-8">Please sign in to your admin account.</p>
              {requestResponse.message && (
                <div className={`mb-6 px-4 py-3 rounded-lg text-sm font-medium text-center ${requestResponse.className} ${isShaking ? 'animate-[shakeError_0.4s_ease-in-out]' : ''}`}>
                  {requestResponse.message}
                </div>
              )}

              {step === "enter_number" ? (
                <Formik
                  key="enter_number"
                  initialValues={{ number: "", role: "admin" }}
                  onSubmit={sendOtp}
                  validationSchema={Yup.object({
                    number: Yup.string()
                      .required("Mobile number is required")
                      .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number"),
                    role: Yup.string().required("Please select a role"),
                  })}
                >
                  {(formik) => (
                    <Form className="space-y-5">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Mobile Number</label>
                        <Field
                          type="text"
                          name="number"
                          placeholder="Enter your 10-digit number"
                          className={`w-full px-4 py-3 rounded-lg border ${formik.errors.number && formik.touched.number
                              ? "border-red-500 focus:ring-red-500"
                              : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                            } focus:outline-none focus:ring-2 transition-all`}
                        />
                        <ErrorMessage name="number" component="div" className="text-red-500 text-xs mt-1 font-medium" />
                      </div>

                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Select Role</label>
                        <Field
                          as="select"
                          name="role"
                          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500 transition-all bg-white"
                        >
                          <option value="admin">Administrator</option>
                          <option value="support">Support Agent</option>
                        </Field>
                        <ErrorMessage name="role" component="div" className="text-red-500 text-xs mt-1 font-medium" />
                      </div>

                      <button
                        type="submit"
                        className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-500/50 transition-all shadow-md mt-4"
                      >
                        Send OTP Code
                      </button>
                    </Form>
                  )}
                </Formik>
              ) : (
                <Formik
                  key="enter_otp"
                  initialValues={{ otp: ['', '', '', ''] }}
                  onSubmit={(values) => {
                    const otpString = values.otp.join('');
                    verifyOtp({ otp: otpString });
                  }}
                  validationSchema={Yup.object({
                    otp: Yup.array()
                      .of(
                        Yup.string()
                          .matches(/^[0-9]$/, "Must be a digit")
                          .required("Required")
                      )
                      .length(4, "OTP must be exactly 4 digits"),
                  })}
                >
                  {(formik) => (
                    <Form className="space-y-6">
                      <div className="text-center mb-6">
                        <h2 className="text-lg font-semibold text-gray-800">Verification Code</h2>
                        <p className="text-sm text-gray-500 mt-1">Enter the 4-digit code sent to +91 {phone}</p>
                      </div>

                      <div className="flex justify-center gap-3 md:gap-4">
                        {[0, 1, 2, 3].map((index) => (
                          <div key={index} className="flex flex-col items-center">
                            <Field
                              innerRef={index === 0 ? firstOtpRef : null}
                              type="text"
                              name={`otp[${index}]`}
                              maxLength={1}
                              inputMode="numeric"
                              pattern="[0-9]*"
                              className={`w-12 h-14 md:w-14 md:h-16 text-center text-2xl font-bold text-gray-800 bg-gray-50 border rounded-xl focus:outline-none transition-all ${formik.errors.otp && formik.errors.otp[index] && formik.touched.otp && formik.touched.otp[index]
                                  ? "border-red-500 focus:ring-red-500"
                                  : "border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                                }`}
                              onInput={(e) => {
                                if (e.target.value.length === 1 && index < 3) {
                                  const nextInput = document.querySelector(`input[name="otp[${index + 1}]"]`);
                                  nextInput?.focus();
                                }
                              }}
                            />
                          </div>
                        ))}
                      </div>

                      {formik.errors.otp && formik.touched.otp && (
                        <div className="text-red-500 text-xs font-medium text-center">Please enter all 4 digits correctly</div>
                      )}

                      <button
                        type="submit"
                        className="w-full bg-gray-900 text-white font-bold py-3.5 px-4 rounded-xl hover:bg-black focus:ring-4 focus:ring-gray-900/30 transition-all shadow-md mt-6"
                      >
                        Verify & Login
                      </button>

                      <div className="text-center mt-6">
                        <button
                          type="button"
                          onClick={() => setStep("enter_number")}
                          className="text-sm font-semibold text-blue-600 hover:text-blue-800 transition-colors inline-flex items-center gap-1"
                        >
                          <span>&larr;</span> Change Mobile Number
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login